import { Menu } from "@/components/Menu";

export interface RowMenuItem {
  key: string;
  label: string;
  /** Every item goes to the record with a question for it (ruling #13): no dialog inside the register. */
  to: string;
}

/**
 * The row's menu (UX gate round 4, #13): the two things a person does to a
 * Vorgang from the list without reading its record first — give it a
 * customer, hand it over. Each item leads to the record with the dialog
 * asked for (`?kunde=1`, `?uebergeben=1`); the record opens it on arrival.
 *
 * The behaviour — placement at the window (the table's frame clips), keys,
 * focus return, the swallowed click of the press that only closed it, closing
 * on a scroll — is `Menu`'s; this only names the trigger and turns each item
 * into a router link.
 */
export function RowMenu({ items, describedBy }: { items: readonly RowMenuItem[]; describedBy?: string }) {
  return (
    <Menu
      label="Weitere Aktionen"
      // 24 px: the row's first line has 2.25 px to spare above and below (Register.module.css, `.when`).
      size="s"
      items={items.map((item) => ({ key: item.key, label: item.label, href: item.to, internal: true }))}
      describedBy={describedBy}
    />
  );
}
